import React from 'react';
import { type CheckboxProps, Checkbox } from '@atlaskit/checkbox';
import { CheckboxLabelContainer } from '../styled.tsx';

export const NotificationsConfigCheckbox = (props: CheckboxProps) => {
	const { label, ...rest } = props;
	return (
		<Checkbox {...rest} label={label && <CheckboxLabelContainer>{label}</CheckboxLabelContainer>} />
	);
};
